/* =========================================================================
   Samenkit aus dem Warenkorb heraus nachlegen.

   Ein Klick auf eine Karte legt das Kit zu und zeichnet den Warenkorb neu —
   ohne die Seite zu laden. Shopify liefert die neuen Bereiche gleich mit
   der Antwort auf /cart/add.js, wenn man sie mitbestellt.

   WARUM DIESELBEN BEREICHE WIE MOTTO:
   Artikelliste, Summen und das Koerbchen im Kopf muessen zusammen aktuell
   sein. Motto listet sie in `CartItems.getSectionsToRender()`; hier steht
   dieselbe Liste, weil dieses Skript ohne jenes Element auskommen soll —
   im Warenkorb-Schubfach gibt es `cart-items` naemlich nicht.

   WARUM EIN LAUSCHER AM DOKUMENT:
   Die Karten stehen INNERHALB von `.js-contents`. Genau dieser Bereich wird
   beim Neuzeichnen ersetzt — an den Karten selbst zu lauschen, hiesse nach
   jedem Klick neu binden. Ein Lauscher weiter oben ueberlebt das.
   ========================================================================= */
(function () {
  'use strict';

  /* Warenkorbseite und Schubfach zeichnen sich verschieden neu.

     Die Seite holt zwei Teile einzeln (Liste und Summen), das Schubfach
     holt sich als Ganzes unter dem Bereichsnamen `cart-drawer`. Steht das
     Schubfach offen, ist es das Sichtbare — dann gilt seine Liste.

     Der Aufbau ist derselbe wie in Mottos `getSectionsToRender()`:
     `rahmen` ist die Id des Elements auf der Seite, `wahl` der Ausschnitt
     darin. Beides wird gebraucht — siehe `einsetzen`. */
  function bereiche() {
    const schubfach = document.querySelector('cart-drawer');
    const korbsymbol = { name: 'cart-icon-bubble', symbol: true };

    if (schubfach && !schubfach.classList.contains('is-empty')
        && schubfach.closest('.drawer, cart-drawer').classList.contains('active')) {
      return [
        { name: 'cart-drawer', rahmen: 'CartDrawer', wahl: null },
        korbsymbol,
      ];
    }

    const liste = [];
    const artikel = document.getElementById('main-cart-items');
    const summen = document.getElementById('main-cart-footer');
    if (artikel) liste.push({ name: artikel.dataset.id, rahmen: 'main-cart-items', wahl: '.js-contents' });
    if (summen) liste.push({ name: summen.dataset.id, rahmen: 'main-cart-footer', wahl: '.js-contents-totals' });
    if (!liste.length && schubfach) {
      liste.push({ name: 'cart-drawer', rahmen: 'CartDrawer', wahl: null });
    }
    liste.push(korbsymbol);
    return liste.filter((x) => x.name);
  }

  /* Das Korbsymbol im Kopf: NUR die Zahl, nicht der ganze Bereich.

     Der Bereich `cart-icon-bubble` liefert `<span>Warenkorb</span>` und die
     Zahlenblase — das Einkaufskorb-Symbol steckt fest im Header und ist
     NICHT darin. Wer den ganzen Bereich einsetzt, wirft das Symbol weg und
     schreibt das Wort „Warenkorb" an seine Stelle. Genau so sah es aus.

     Drei Faelle: Blase da und geliefert → Inhalt tauschen. Vorher keine
     (Korb war leer) → anhaengen. Keine mehr geliefert → entfernen. */
  function symbolAktualisieren(roh) {
    const anker = document.getElementById('cart-icon-bubble');
    if (!anker || !roh) return;

    const dort = new DOMParser().parseFromString(roh, 'text/html').querySelector('.cart-count-bubble');
    const hier = anker.querySelector('.cart-count-bubble');

    if (dort && hier) hier.innerHTML = dort.innerHTML;
    else if (dort) anker.appendChild(dort);
    else if (hier) hier.remove();
  }

  /* Aus dem gelieferten HTML den einen Ausschnitt herausschneiden und
     einsetzen. `innerHTML` und nicht `replaceWith`: der Rahmen traegt die
     Klasse, an der Motto und wir haengen.

     DIE SUCHE MUSS IM RAHMEN STATTFINDEN, nicht im ganzen Dokument.
     `.shopify-section` gibt es auf jeder Seite dutzendfach; ein globales
     `querySelector` traf die ERSTE davon — die Ankuendigungsleiste — und
     schrieb ihr den Inhalt des Warenkorbsymbols hinein. Auf der
     Warenkorbseite stand danach oben links „Warenkorb 4" als nackter Text.
     Genau so gesehen.

     Der Rueckfall auf den Rahmen selbst ist Mottos: findet sich der
     Ausschnitt darin nicht, wird der Rahmen ersetzt. */
  function einsetzen(liste, gelieferte) {
    liste.forEach((b) => {
      const roh = gelieferte[b.name];
      if (!roh) return;

      if (b.symbol) {
        symbolAktualisieren(roh);
        return;
      }

      const rahmen = document.getElementById(b.rahmen);
      if (!rahmen) return;
      const hier = (b.wahl && rahmen.querySelector(b.wahl)) || rahmen;

      const dok = new DOMParser().parseFromString(roh, 'text/html');
      const dort = b.wahl ? dok.querySelector(b.wahl) : dok.getElementById(b.rahmen);
      if (dort) hier.innerHTML = dort.innerHTML;
    });
  }

  function zulegen(knopf) {
    const id = Number(knopf.getAttribute('data-ug-korb-samen-id'));
    if (!id || knopf.disabled) return;
    knopf.disabled = true;
    knopf.classList.add('ug-karte--laedt');

    const liste = bereiche();
    const ziel = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(ziel, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id, quantity: 1 }],
        sections: liste.map((b) => b.name),
        sections_url: window.location.pathname,
      }),
    })
      .then((a) => a.json())
      .then((d) => {
        if (d.status) throw new Error(d.description || d.message || 'abgelehnt');
        if (d.sections) einsetzen(liste, d.sections);

        /* Die gelegte Karte selbst wegräumen.

           WARUM NICHT EINFACH NEU ZEICHNEN LASSEN: Auf der Warenkorbseite
           steht das Angebot seit dem Umbau UNTER dem Kassenknopf, also
           ausserhalb von `.js-contents` und `.js-contents-totals` — den
           beiden Bereichen, die Motto nachlaedt. Es bliebe dort also stehen,
           obwohl das Kit schon im Korb liegt.

           Den ganzen Fuss nachzuladen waere die naheliegende Loesung und
           die schlechtere: darin stecken die Express-Knoepfe von Apple Pay
           und Google Pay. Die kommen aus fremden Rahmen, und wer sie neu
           einsetzt, hat gute Chancen, sie tot zu machen.

           Bleibt keine Karte uebrig, verschwindet der ganze Block: eine
           Ueberschrift ohne Angebot darunter sieht nach Fehler aus. */
        const reihe = knopf.closest('.ug-karten');
        knopf.remove();
        if (reihe && !reihe.querySelector('[data-ug-korb-samen-id]')) {
          const block = reihe.closest('.ug-korb-samen');
          if (block) block.remove();
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch((e) => {
        /* Fehlgeschlagen heisst: Karte wieder anklickbar. Ein stiller
           Knopf, der nichts tut, ist schlimmer als ein zweiter Versuch. */
        knopf.disabled = false;
        knopf.classList.remove('ug-karte--laedt');
        if (window.console) console.warn('Warenkorb: Samenkit nicht zugelegt —', e);
      });
  }

  document.addEventListener('click', (e) => {
    const knopf = e.target.closest('[data-ug-korb-samen-id]');
    if (knopf) zulegen(knopf);
  });
})();
